<template>
  <q-card :inline="inline" class="customer-card bg-white" :class="{ 'no-margin': !margin, 'customer-card--modal': inModal }">
    <q-card-media class="customer-card__header">
      <q-icon
        @click.native="handleClose"
        class="customer-card__header__close cursor-pointer"
        name="close"
        color="grey-11"
        size="1.4em"
      />

      <q-icon class="customer-card__header__dropdown" name="more_vert" color="white" size="1.5rem">
        <customer-popover :customers="[customer]"></customer-popover>
      </q-icon>

      <img class="fit" src="~assets/img/banner.png">

      <q-card-title slot="overlay" class="text-center">
        <template>
          <span>
            {{ customerName }}
          </span>
        </template>
      </q-card-title>
    </q-card-media>
    <q-card-main class="customer-card__content">
      <q-tabs color="white" underline-color="primary" class="customer-card__tabs">
        <q-tab name="general" slot="title" default :label="$t('general')" color="black"/>
        <q-tab name="contact-person" slot="title" :label="$tc('contact_person', 2)" color="black" v-if="!isPerson"/>
        <q-tab name="projects" slot="title" :label="$tc('project', 2)" color="black"/>
        <q-tab name="invoices" slot="title" :label="$tc('invoice', 2)" color="black"/>
        <q-tab name="quotes" slot="title" :label="$tc('quote', 2)" color="black"/>
        <q-tab name="notes" slot="title" :label="$tc('note', 2)" color="black"/>

        <general-tab :customer="customer"></general-tab>
        <contact-person-tab :customer="customer" v-if="!isPerson"></contact-person-tab>
        <invoices-tab :customer="customer"></invoices-tab>
        <quotes-tab :customer="customer"></quotes-tab>
        <notes-tab :customer="customer"></notes-tab>
        <projects-tab :customer="customer"></projects-tab>
      </q-tabs>
    </q-card-main>
  </q-card>
</template>

<script>
  import ContactPersonTab from './CustomerCardTabs/ContactPerson.vue'
  import CustomerPopover from './CustomerPopover.vue'
  import GeneralTab from './CustomerCardTabs/General.vue'
  import InvoicesTab from './CustomerCardTabs/Invoices.vue'
  import NotesTab from './CustomerCardTabs/Notes.vue'
  import ProjectsTab from './CustomerCardTabs/Projects.vue'
  import QuotesTab from './CustomerCardTabs/Quotes.vue'
  import { getCustomerName } from 'src/utils/searchResultParser'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      inline: {
        type: Boolean
      },
      inModal: {
        type: Boolean,
        default: false
      },
      margin: {
        type: Boolean,
        default: false
      },
      customer: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters(['activeTeam']),

      isPerson () {
        return this.customer.type === 'person'
      },

      customerName () {
        return getCustomerName(this.customer)
      }
    },

    methods: {
      handleClose () {
        this.$router.push({ name: 'customers', params: { teamId: this.activeTeam.id } })
      }
    },

    components: {
      CustomerPopover,
      GeneralTab,
      InvoicesTab,
      NotesTab,
      QuotesTab,
      ProjectsTab,
      ContactPersonTab
    }
  }
</script>

<style src="./styles/customer-card.styl" lang="stylus"></style>
